module.exports = __webpack_public_path__ + "img/logo.5bc117bb.jpg";